import getExtensionFromPath from '@anm/helpers/getExtensionFromPath';

var isStreamVideo = function isStreamVideo(videoUrl) {
  return getExtensionFromPath(videoUrl) === 'm3u8';
};

export default isStreamVideo;